
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toyama",
      function () {
        return require("private-next-pages/toyama/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/toyama"])
      });
    }
  